import { Box } from 'components/Box/Box';
import { RedirectToExternalUrl } from 'components/RedirectToExternalUrl/RedirectToExternalUrl';
import { SpinnerOverlay } from 'components/SpinnerOverlay/SpinnerOverlay';
import { Button } from 'components/ui/Button/Button';
import { Heading } from 'components/ui/Heading/Heading';
import { FIVE_SECONDS_IN_MS } from 'constants/index';
import { useEmbeddedProps } from 'hooks';
import { ReactComponent as Icon } from 'icons/ico-complete-payment.svg';
import { ReactComponent as InfoIcon } from 'icons/ico-info-current-color.svg';
import { useState } from 'react';
import { RedirectUrl, useTranslations } from 'utils';

export const offersWithExpirationInMinutes = {
  adyen_ideal_eur: 30,
  adyen_twint_chf: 20,
};

export type RedirectionInstructionsProps = {
  forceRedirectInNewWindow: boolean;
  offerName: string;
  partnerUrl: string;
  paymentOption: unknown;
  paymentId: string;
  returnUrl: string;
};

export function RedirectionInstructions({
  forceRedirectInNewWindow,
  offerName,
  partnerUrl,
  paymentOption,
  paymentId,
  returnUrl,
}: RedirectionInstructionsProps) {
  const i18n = useTranslations();
  const [redirectToURL, setRedirectToURL] = useState(false);
  const { fwFinish, return_type: returnType } = useEmbeddedProps();
  const isIframeIntegration = returnType === 'postMessage';

  const offerExpiration = offersWithExpirationInMinutes[paymentOption];
  const shouldRedirect = redirectToURL && partnerUrl;

  return (
    <Box>
      {shouldRedirect && (
        <SpinnerOverlay
          message={
            i18n.t('online.redirectMessage', { name: offerName }) as string
          }
        >
          <RedirectToExternalUrl url={partnerUrl} delay={FIVE_SECONDS_IN_MS} />
        </SpinnerOverlay>
      )}
      <div className="textAlign-center">
        <Icon />
        <Heading as="h3" size="large">
          {i18n.t('online.script.title')}
        </Heading>
        <p>{i18n.t('online.script.description')}</p>
        {forceRedirectInNewWindow ? (
          <a
            className="Button Button--primary Online-button"
            href={partnerUrl}
            onClick={() => {
              if (isIframeIntegration) {
                const redirectUrl = RedirectUrl.build(
                  returnUrl,
                  paymentId,
                  'pending',
                );
                fwFinish(redirectUrl, true);
              }
            }}
            target="_blank"
            rel="noreferrer"
          >
            {i18n.t('online.instructions.button')}
          </a>
        ) : (
          <Button
            id="payment-trigger"
            type="button"
            onClick={() => {
              setRedirectToURL(true);
            }}
            className="Button Button--primary Online-button"
            tone="primary"
            size="full"
          >
            {i18n.t('online.instructions.button')}
          </Button>
        )}
        {offerExpiration && (
          <div className="RedirectionInstructions-offerExpiration">
            <InfoIcon
              height="12"
              width="12"
              className="marginRight-sm"
              aria-hidden="true"
            />
            <p>
              {i18n.t('online.instructions.offer.expiration', {
                minutes: offerExpiration,
              })}
            </p>
          </div>
        )}
      </div>
    </Box>
  );
}
